export const brussels = [
  {
    ll_id: "c05c554c-755c-4d0f-bc39-cec51fa2adb6",
    ll_name: "Reservation brussels",
    ru_id: "206190",
    verified: "yes",
    city: "brussels",
    neigbourhood: "brussels",
    ll_engagement: "high",
    property_type: "studio",
    rooms: "0",
    price: "575",
    price_vs_Market: "-675",
    available_from: "12/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/206190",
  },
  {
    ll_id: "c05c554c-755c-4d0f-bc39-cec51fa2adb6",
    ll_name: "Reservation brussels",
    ru_id: "124566",
    verified: "yes",
    city: "brussels",
    neigbourhood: "brussels",
    ll_engagement: "high",
    property_type: "apartment",
    rooms: "1",
    price: "900",
    price_vs_Market: "-500",
    available_from: "12/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/124566",
  },
  {
    ll_id: "c05c554c-755c-4d0f-bc39-cec51fa2adb6",
    ll_name: "Reservation brussels",
    ru_id: "124573",
    verified: "yes",
    city: "brussels",
    neigbourhood: "brussels",
    ll_engagement: "high",
    property_type: "apartment",
    rooms: "1",
    price: "915",
    price_vs_Market: "-485",
    available_from: "12/17/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/124573",
  },
  {
    ll_id: "ca2b5b8c-fef4-4f7d-a49c-dff36325a08d",
    ll_name: "Eric Molehant",
    ru_id: "122771",
    verified: "yes",
    city: "brussels",
    neigbourhood: "jette",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "1",
    price: "750",
    price_vs_Market: "-450",
    available_from: "10/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/122771",
  },
  {
    ll_id: "3cc8a990-ca2f-485d-a950-50532e7e6362",
    ll_name: "Bjorn Vankerkhoven AtWorkForYou",
    ru_id: "281846",
    verified: "yes",
    city: "brussels",
    neigbourhood: "etterbeek",
    ll_engagement: "high",
    property_type: "apartment",
    rooms: "1",
    price: "750",
    price_vs_Market: "-450",
    available_from: "11/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/281846",
  },
  {
    ll_id: "681f5c32-f2aa-4ef7-a3e6-b5c276ed302b",
    ll_name: "Immo .",
    ru_id: "588460",
    verified: "no",
    city: "brussels",
    neigbourhood: "anderlecht",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "2",
    price: "440",
    price_vs_Market: "-440",
    available_from: "12/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/588460",
  },
  {
    ll_id: "3cc8a990-ca2f-485d-a950-50532e7e6362",
    ll_name: "Bjorn Vankerkhoven AtWorkForYou",
    ru_id: "355646",
    verified: "yes",
    city: "brussels",
    neigbourhood: "brussels",
    ll_engagement: "high",
    property_type: "apartment",
    rooms: "1",
    price: "760",
    price_vs_Market: "-430",
    available_from: "12/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/355646",
  },
  {
    ll_id: "e8332534-f469-4335-ae91-4b3e7f9864b6",
    ll_name: "Adnan Sheikh",
    ru_id: "359865",
    verified: "yes",
    city: "brussels",
    neigbourhood: "molenbeek-saint-jean",
    ll_engagement: "high",
    property_type: "apartment",
    rooms: "1",
    price: "780",
    price_vs_Market: "-420",
    available_from: "10/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/359865",
  },
  {
    ll_id: "155aee59-5877-4480-a205-773491ba04ae",
    ll_name: "Marie Beghin",
    ru_id: "444258",
    verified: "no",
    city: "brussels",
    neigbourhood: "ixelles",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "1",
    price: "1150",
    price_vs_Market: "-420",
    available_from: "12/3/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/444258",
  },
  {
    ll_id: "9d435e4b-3cf9-4a97-9014-7a9c38c444ad",
    ll_name: "Alexandre NAILIS",
    ru_id: "124653",
    verified: "yes",
    city: "brussels",
    neigbourhood: "brussels",
    ll_engagement: "high",
    property_type: "studio",
    rooms: "0",
    price: "650",
    price_vs_Market: "-410",
    available_from: "12/25/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/124653",
  },
  {
    ll_id: "0101afb0-c0be-4ffc-b054-03cceef88e96",
    ll_name: "eric delcommenne",
    ru_id: "353663",
    verified: "yes",
    city: "brussels",
    neigbourhood: "ixelles",
    ll_engagement: "medium",
    property_type: "studio",
    rooms: "0",
    price: "495",
    price_vs_Market: "-335",
    available_from: "12/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/353663",
  },
  {
    ll_id: "ff8b728f-2dad-4fb1-959d-e0b246b35bf3",
    ll_name: "IKOAB",
    ru_id: "404553",
    verified: "no",
    city: "brussels",
    neigbourhood: "saint-gilles",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "10",
    price: "525",
    price_vs_Market: "-335",
    available_from: "12/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/404553",
  },
  {
    ll_id: "ff8b728f-2dad-4fb1-959d-e0b246b35bf3",
    ll_name: "IKOAB",
    ru_id: "404562",
    verified: "no",
    city: "brussels",
    neigbourhood: "saint-gilles",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "10",
    price: "525",
    price_vs_Market: "-335",
    available_from: "12/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/404562",
  },
  {
    ll_id: "3cc8a990-ca2f-485d-a950-50532e7e6362",
    ll_name: "Bjorn Vankerkhoven AtWorkForYou",
    ru_id: "258600",
    verified: "yes",
    city: "brussels",
    neigbourhood: "ixelles",
    ll_engagement: "high",
    property_type: "studio",
    rooms: "0",
    price: "510",
    price_vs_Market: "-320",
    available_from: "12/16/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/258600",
  },
  {
    ll_id: "c05c554c-755c-4d0f-bc39-cec51fa2adb6",
    ll_name: "Reservation brussels",
    ru_id: "461284",
    verified: "yes",
    city: "brussels",
    neigbourhood: "brussels",
    ll_engagement: "high",
    property_type: "apartment",
    rooms: "1",
    price: "1100",
    price_vs_Market: "-300",
    available_from: "11/2/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/461284",
  },
  {
    ll_id: "5060a20c-d3d4-4147-9bbb-b4cba0fe82a4",
    ll_name: "Hotel Queen Anne s.a.",
    ru_id: "121000",
    verified: "yes",
    city: "brussels",
    neigbourhood: "brussels",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "1",
    price: "900",
    price_vs_Market: "-300",
    available_from: "10/23/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/121000",
  },
  {
    ll_id: "3cc8a990-ca2f-485d-a950-50532e7e6362",
    ll_name: "Bjorn Vankerkhoven AtWorkForYou",
    ru_id: "300088",
    verified: "yes",
    city: "brussels",
    neigbourhood: "brussels",
    ll_engagement: "high",
    property_type: "studio",
    rooms: "0",
    price: "510",
    price_vs_Market: "-260",
    available_from: "12/16/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/300088",
  },
  {
    ll_id: "7e6ece04-59ea-4020-afdc-b224ea6c9062",
    ll_name: "The Soap Factory",
    ru_id: "144055",
    verified: "yes",
    city: "brussels",
    neigbourhood: "saint-josse-ten-noode",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "10",
    price: "470",
    price_vs_Market: "-250",
    available_from: "11/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/144055",
  },
  {
    ll_id: "659fb7f6-a1e3-4307-ac83-7c0fb582068b",
    ll_name: "Anne-Charlotte d'Aspremont Lynden",
    ru_id: "607298",
    verified: "no",
    city: "brussels",
    neigbourhood: "uccle",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "1",
    price: "1300",
    price_vs_Market: "-250",
    available_from: "10/18/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/607298",
  },
  {
    ll_id: "df3ac7c2-27ba-4b1e-9662-ee83a13170ed",
    ll_name: "Raphaël Schlussel",
    ru_id: "447265",
    verified: "yes",
    city: "brussels",
    neigbourhood: "saint-josse-ten-noode",
    ll_engagement: "high",
    property_type: "apartment",
    rooms: "1",
    price: "1000",
    price_vs_Market: "-230",
    available_from: "12/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/447265",
  },
  {
    ll_id: "c11fbe7d-d55b-447a-9ecb-4d4179cf0ff4",
    ll_name: "Rawa .",
    ru_id: "588492",
    verified: "no",
    city: "brussels",
    neigbourhood: "brussels",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "1",
    price: "1050",
    price_vs_Market: "-230",
    available_from: "12/26/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/588492",
  },
  {
    ll_id: "aab2b51e-346a-4bf7-8cf5-55e017438e24",
    ll_name: "Raffaella Battella",
    ru_id: "110236",
    verified: "yes",
    city: "brussels",
    neigbourhood: "brussels",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "2",
    price: "1133.333333",
    price_vs_Market: "-216.6666667",
    available_from: "10/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/110236",
  },
  {
    ll_id: "129863d6-b4d3-467d-b71e-9d71790600f6",
    ll_name: "Jean-Jacques HERMAN",
    ru_id: "95695",
    verified: "yes",
    city: "brussels",
    neigbourhood: "brussels",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "1",
    price: "380",
    price_vs_Market: "-210",
    available_from: "12/23/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/95695",
  },
  {
    ll_id: "f250073b-3af1-4349-8679-20bf58ec0128",
    ll_name: "Easy Stay Brussels",
    ru_id: "262017",
    verified: "yes",
    city: "brussels",
    neigbourhood: "brussels",
    ll_engagement: "high",
    property_type: "apartment",
    rooms: "2",
    price: "1400",
    price_vs_Market: "-210",
    available_from: "11/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/262017",
  },
  {
    ll_id: "0c28b271-aa02-44c0-8340-37d5f7cee8fe",
    ll_name: "Helene Melikov",
    ru_id: "318341",
    verified: "yes",
    city: "brussels",
    neigbourhood: "brussels",
    ll_engagement: "high",
    property_type: "studio",
    rooms: "0",
    price: "750",
    price_vs_Market: "-210",
    available_from: "11/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/318341",
  },
  {
    ll_id: "d383003a-531d-4c3e-af8b-04e83bd4e91f",
    ll_name: "Rachida Messaouri",
    ru_id: "101713",
    verified: "yes",
    city: "brussels",
    neigbourhood: "ixelles",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "1",
    price: "995",
    price_vs_Market: "-205",
    available_from: "10/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/101713",
  },
  {
    ll_id: "61fa8f80-7c93-424f-b067-2256be85f0a2",
    ll_name: "Steve HENROTTE BERY INVEST SPRL",
    ru_id: "101429",
    verified: "yes",
    city: "brussels",
    neigbourhood: "etterbeek",
    ll_engagement: "high",
    property_type: "studio",
    rooms: "0",
    price: "695",
    price_vs_Market: "-205",
    available_from: "12/10/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/101429",
  },
  {
    ll_id: "3cc8a990-ca2f-485d-a950-50532e7e6362",
    ll_name: "Bjorn Vankerkhoven AtWorkForYou",
    ru_id: "361903",
    verified: "yes",
    city: "brussels",
    neigbourhood: "brussels",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "2",
    price: "440",
    price_vs_Market: "-190",
    available_from: "12/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/361903",
  },
  {
    ll_id: "e6ccac43-6ac9-4903-a742-8e993cb45b41",
    ll_name: "Khachatryan Lianna",
    ru_id: "608471",
    verified: "no",
    city: "brussels",
    neigbourhood: "forest",
    ll_engagement: "medium",
    property_type: "studio",
    rooms: "0",
    price: "650",
    price_vs_Market: "-190",
    available_from: "12/26/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/608471",
  },
  {
    ll_id: "c05c554c-755c-4d0f-bc39-cec51fa2adb6",
    ll_name: "Reservation brussels",
    ru_id: "575900",
    verified: "no",
    city: "brussels",
    neigbourhood: "brussels",
    ll_engagement: "high",
    property_type: "studio",
    rooms: "0",
    price: "475",
    price_vs_Market: "-185",
    available_from: "12/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/575900",
  },
  {
    ll_id: "b36cacb8-73a1-4219-93a5-3973ccbc38e4",
    ll_name: "hugo kerkhofs",
    ru_id: "280297",
    verified: "yes",
    city: "brussels",
    neigbourhood: "anderlecht",
    ll_engagement: "high",
    property_type: "studio",
    rooms: "0",
    price: "690",
    price_vs_Market: "-130",
    available_from: "9/30/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/280297",
  },
  {
    ll_id: "3befe76f-72fd-4f1c-afd0-04885f2b05a8",
    ll_name: "Alexis De Bosscher",
    ru_id: "512700",
    verified: "yes",
    city: "brussels",
    neigbourhood: "schaerbeek",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "3",
    price: "450",
    price_vs_Market: "-130",
    available_from: "12/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/512700",
  },
  {
    ll_id: "436b26c0-b860-49e6-a5d8-73b31815e997",
    ll_name: "CHHIV Mealea",
    ru_id: "155408",
    verified: "yes",
    city: "brussels",
    neigbourhood: "saint-josse-ten-noode",
    ll_engagement: "medium",
    property_type: "studio",
    rooms: "0",
    price: "845",
    price_vs_Market: "-125",
    available_from: "11/11/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/155408",
  },
  {
    ll_id: "ff8b728f-2dad-4fb1-959d-e0b246b35bf3",
    ll_name: "IKOAB",
    ru_id: "322974",
    verified: "no",
    city: "brussels",
    neigbourhood: "etterbeek",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "8",
    price: "525",
    price_vs_Market: "-105",
    available_from: "12/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/322974",
  },
  {
    ll_id: "ff8b728f-2dad-4fb1-959d-e0b246b35bf3",
    ll_name: "IKOAB",
    ru_id: "322948",
    verified: "no",
    city: "brussels",
    neigbourhood: "saint-josse-ten-noode",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "15",
    price: "625",
    price_vs_Market: "-95",
    available_from: "12/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/322948",
  },
  {
    ll_id: "ff8b728f-2dad-4fb1-959d-e0b246b35bf3",
    ll_name: "IKOAB",
    ru_id: "322941",
    verified: "no",
    city: "brussels",
    neigbourhood: "saint-josse-ten-noode",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "15",
    price: "625",
    price_vs_Market: "-95",
    available_from: "12/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/322941",
  },
  {
    ll_id: "5e11849a-e876-4f0e-9e46-e4115014c84f",
    ll_name: "Luc Donck",
    ru_id: "605848",
    verified: "no",
    city: "brussels",
    neigbourhood: "woluwe-saint-lambert",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "7",
    price: "460",
    price_vs_Market: "-90",
    available_from: "11/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/605848",
  },
  {
    ll_id: "5e11849a-e876-4f0e-9e46-e4115014c84f",
    ll_name: "Luc Donck",
    ru_id: "605847",
    verified: "no",
    city: "brussels",
    neigbourhood: "woluwe-saint-lambert",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "7",
    price: "460",
    price_vs_Market: "-90",
    available_from: "11/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/605847",
  },
  {
    ll_id: "5e11849a-e876-4f0e-9e46-e4115014c84f",
    ll_name: "Luc Donck",
    ru_id: "605846",
    verified: "no",
    city: "brussels",
    neigbourhood: "woluwe-saint-lambert",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "7",
    price: "460",
    price_vs_Market: "-90",
    available_from: "11/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/brussels/for-rent:apartments/605846",
  },
];
